import { Laboratory } from '@medprev-web-app/api-graphql-client';

import { mapSearchApiRating } from '@/app/(main)/(pages)/_services/search-api/map-search-api-rating.util';
import {
  SearchApiFacility,
  SearchApiPartner,
  SearchApiRating,
} from '@/app/(main)/(pages)/_types/search-api-response.type';

export function mapSearchApiLaboratory(
  facility: SearchApiFacility,
  partner: SearchApiPartner | null,
  rating: SearchApiRating | null,
): Laboratory {
  const socialName = partner?.socialName ?? facility.partner?.socialName ?? null;

  return {
    id: facility.id,
    name: facility.name ?? null,
    slug: facility.slug ?? null,
    type: facility.type ?? null,
    city: facility.city ?? null,
    state: facility.state ?? null,
    neighborhood: facility.neighborhood ?? null,
    zipcode: facility.zipcode ?? null,
    addressLine1: facility.addressLine1 ?? null,
    addressLine2: facility.addressLine2 ?? null,
    number: facility.number ?? null,
    latitude: facility.latitude ?? null,
    longitude: facility.longitude ?? null,
    avatar: partner?.avatar ?? facility.partner?.avatar ?? null,
    description: facility.description ?? partner?.description ?? null,
    distance: null,
    structure: {
      airConditioning: facility.structure?.airConditioning ?? false,
      elevator: facility.structure?.elevator ?? false,
      parking: facility.structure?.parking ?? false,
      specialAccess: facility.structure?.specialAccess ?? false,
    },
    rating: mapSearchApiRating(rating),
    facilityImages: (facility.images ?? []).map((image) => ({
      id: image.id ?? null,
      name: image.name ?? null,
      src: image.src ?? null,
    })),
    main: {
      id: partner?.id ?? facility.partnerId ?? facility.partner?.id ?? null,
      socialName,
      legalName: partner?.legalName ?? socialName,
      avatar: partner?.avatar ?? facility.partner?.avatar ?? null,
      description: partner?.description ?? null,
    },
  };
}
